
import React, { useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import { Box, Typography, useTheme, InputBase, IconButton, Button } from "@mui/material";
import { ResponsivePie } from "@nivo/pie";
import { tokens } from "../../theme";
import ModalMotivosCalandra from "../../modal/motivosCalandra/modalMotivosCalandra";
import { getOneDatosTicket, PostCalandra, getOneProducto, PostDatosCalandra } from "../../services/calandra.services";
import { getOrdenOne, getTemperatura, getSerie } from "../../services/ordenProduccion.services";
import { getDatosProduccion } from "../../services/graficos.services";
import LinearProgress from "@mui/material/LinearProgress";
import ModalReImpresion from '../../modal/reImpresion/modalReImpresion';
import ModalClasificacion from "../../modal/clasificacion/modalClasificacion";
import SendIcon from '@mui/icons-material/Send';
import ModalCharge from "../../modal/modalCharge";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { getOneDatos, getOnePvbView} from "../../services/pvb.services";
import getUrlSocket from '../../utils/getUrlSocket';
import { getOneDatosCargadoraCab } from "../../services/cargadora.services";
import secureStorage from "../../utils/secureStorage";

const SOCKET_URL = getUrlSocket();
const socket = io(SOCKET_URL, {
  withCredentials: true,
  transports: ["websocket", "polling"],
  query: {
    token: secureStorage.getItem("authToken"),
  },
});


const CalandraDatosProductos = (props) => {
  const [data, setData] = useState([]);
  const [xd, setxd] = useState([]);
  const [PVB, setPvb] = useState(() => {
    // Recuperar la orden del localStorage al cargar la página
    return secureStorage.getItem("pvb") || "";
  });;
  const [chapa1, setChapa1] = useState("");
  const [chapa2, setChapa2] = useState("");
  const [printerInfo, setPrinterInfo] = useState(''); // Estado para guardar la información de la impresora
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [xdd, setxdd] = useState("");
  const [serieValue, setSerieValue] = useState(""); // Estado para la serie
  const [modalOpenClasifi, setModalOpenClasifi] = useState(false);
  const [productData, setProductData] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenMotivo, setModalOpenMotivo] = useState(false);
  const [temperatura, setTemperatura] = useState([]);
  const [modalOpenReImpresion, setModalOpenReImpresion] = useState(false);
  const [chapas, setChapas] = useState(20); // Valor actual de chapas
  const [chapasT, setChapasT] = useState(100); // Valor total de chapas
  const [produccionPeriodos, setProduccionPeriodos] = useState({ actual: 0, semana: 0, mes: 0 });
  const [showCelebration, setShowCelebration] = useState(false);
  const [celebrationMessage, setCelebrationMessage] = useState("");
  const [pvbData, setPvbData] = useState({ codigo: "", media: 0 });
  const metasCelebradasRef = useRef({ actual: false, semana: false, mes: false });
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const USER = parseInt(secureStorage.getItem('id'));
  const META_TURNO = 150;
  const META_SEMANA = 750;
  const META_MES = 3000;
  const TURNOS_CONFIG = {
    3: {
      nombre: "1er Turno",
      horario: "03:00-11:00",
      dataKey: "total_primer_turno",
      inicio: { hour: 3, minute: 0 },
      fin: { hour: 11, minute: 0 },
      cruzaDia: false,
    },
    4: {
      nombre: "2do Turno",
      horario: "11:00-19:30",
      dataKey: "total_segundo_turno",
      inicio: { hour: 11, minute: 0 },
      fin: { hour: 19, minute: 30 },
      cruzaDia: false,
    },
    12: {
      nombre: "3er Turno",
      horario: "19:30-03:00",
      dataKey: "total_tercer_turno",
      inicio: { hour: 19, minute: 30 },
      fin: { hour: 3, minute: 0 },
      cruzaDia: true,
    },
  };
  const getTurnoIdByHora = () => {
    const ahora = dayjs();
    const minutos = ahora.hour() * 60 + ahora.minute();

    const inicioPrimerTurno = 3 * 60;
    const inicioSegundoTurno = 11 * 60;
    const inicioTercerTurno = 19 * 60 + 30;

    if (minutos >= inicioPrimerTurno && minutos < inicioSegundoTurno) return 3;
    if (minutos >= inicioSegundoTurno && minutos < inicioTercerTurno) return 4;
    return 12;
  };

  const turnoIdEfectivo = getTurnoIdByHora();
  const turnoConfig = TURNOS_CONFIG[turnoIdEfectivo] || TURNOS_CONFIG[12];

  const fetchProducto = async (idProducto) => {
    if (!idProducto) return;
    try {
      const producto = await getOneProducto(idProducto);
      setProductData(producto || "");
    } catch (error) {
      console.error("Error al obtener producto:", error.message);
      setProductData("");
    }
  };



  const [selectData, setSelectData] = useState({
    id: "",
    orden: "",
    cod: "",
    cantidad_total: "0",
    producidos: "0",
    Estado: "",
    descripcion: "",
    pvb: "",
    create_at: "",
    clasificacion: "",
    defecto: "",
    temperatura: "",
    id_caballete: "",
    id_clasificacion: "",
    motivo: "",
    obs: " ",
  });

  useEffect(() => {
    const fetchSerieData = async () => {
      socket.on("ProduccionUpdated", async (data) => {
      console.log("🚀 ~ fetchSerieData ~ data:", data)
  
        if (data.response && data.response.orden) {
          const orden = data.response?.orden;
          const pvb = data.response?.pvb;
  
          try {
            const reponse = await getSerie(orden);
            await fetchProducto(data.response?.id_producto);
            secureStorage.setItem("paquete1", reponse[0]?.caballete1 || "");
            secureStorage.setItem("paquete2", reponse[0]?.caballete2 || "");
            secureStorage.setItem("orden", reponse[0]?.orden || "");
            secureStorage.setItem("estado_calandra", reponse[0]?.estado_calandra || "");
            secureStorage.setItem("orden", reponse[0]?.orden || "");
            
            const paquete1 = secureStorage.getItem("paquete1");
            const paquete2 = secureStorage.getItem("paquete2");
            // const orden = secureStorage.getItem("orden");
  
            if (orden != null) {
              setSl(orden);
              setEstadoCalandra(data.response.estado_calandra);
              setEstado(data.response.estado);
            }
            setPvb(data.response.pvb);
            fetchData(data.response);
            fetchSerie(orden);
  
            if (data.response.pvb) {
              veririfyPvb(data.response.pvb);
            }
  
            // if (paquete1) {
            //   veririfyPaquete1(paquete1);
            // }
  
            // if (paquete2) {
            //   veririfyPaquete2(paquete2);
            // }
          } catch (error) {
            console.error("Error obteniendo la serie:", error);
          }
        } else {
          console.warn("No se recibió una orden válida desde el socket.");
        }
      });
    };
  
    fetchSerieData();
  
    return () => {
      socket.off("ProduccionUpdated");
    };
  }, []);
  

  const [sl, setSl] = useState(() => {
    // Recuperar la orden del localStorage al cargar la página
    return secureStorage.getItem("orden") || "";
  });
  const [EstadoCalandre, setEstadoCalandra] = useState(() => {
    // Recuperar la orden del localStorage al cargar la página
    return secureStorage.getItem("estado_calandra") || "";
  });
  const [Estado, setEstado] = useState(() => {
    // Recuperar la orden del localStorage al cargar la página
    return secureStorage.getItem("Estado") || "";
  });
  const paquete1 = secureStorage.getItem("paquete1");
    let paquete2 = secureStorage.getItem("paquete2");

    // Si paquete2 está vacío, asignar el valor de paquete1
    if (!paquete2) {
        paquete2 = paquete1;
        secureStorage.setItem("paquete2", paquete2);
    }


  useEffect(() => {
    if (sl && sl !== "" && sl !== null && sl !== undefined && sl>0) {
      
      const orden = {
        orden: sl,
        estado_calandra: EstadoCalandre,
        estado: Estado,
      };
  
      fetchData(orden);
      fetchSerie(sl);
    }
  }, [sl]);
  

    const fetchSerie = async (orden) => {
      if (orden) {
        try {
          const data = await getSerie(orden);
          setPvb(data[0].pvb)
          await fetchProducto(data[0]?.id_producto);
          // Verifica si data.serie es un arreglo y tiene elementos
          if (Array.isArray(data) && data.length > 0) {
            const serieValue = data[0]; // Obtiene el valor de serie
            setxdd(serieValue); // Asigna los datos obtenidos al estado
          } else {
            console.warn("No se encontró la serie en los datos recibidos.");
            setxdd("Sin datos disponibles"); // Valor predeterminado
          }
        } catch (error) {
          console.error("Error al obtener datos:", error.message);
          setxdd("Error al obtener datos"); // Manejo en caso de error
        }
      } else {
        console.warn("Orden no proporcionada.");
      }
    };

    const HandleCargadoraPaquete = async (cab) => {
      try {
        const response = await getOneDatosCargadoraCab(cab);
        return response?.cod_interno || null;
      } catch (error) {
        console.error("Error al obtener datos del backend:", error);
        return null;
      }
    };

    const getPaquete = async () => {
      const selectedCaballetes = JSON.parse(secureStorage.getItem("selectedCaballetes") || "[]");
    
      const caballete1 = selectedCaballetes[0];
      const caballete2 = selectedCaballetes[1];
    
      const resp = await HandleCargadoraPaquete(caballete1);
      const resp2 = await HandleCargadoraPaquete(caballete2);
    
      secureStorage.setItem("paquete1", resp);
      secureStorage.setItem("paquete2", resp2);
    }

  const veririfyPvb = async (pvb) => {
    try {
      const response = await getOneDatos(pvb);
      console.log("🚀 ~ veririfyPvb ~ response:", response)
      // Guardar datos del PVB (código y media disponible)
      setPvbData({
        codigo: response.cod_interno || "Sin código",
        media: response.largo || 0,
      });
      if(response.largo<=3000){
        toast.error(
          `Registrar nuevo PVB en Sala Limpia`,
          {
            position: "top-center",
            autoClose: 9000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          }
        );
      }
    } catch (error) {
      console.error("Error al obtener datos del PVB:", error);
      setPvbData({ codigo: "Error", media: 0 });
    }
  }

    const handleCloseModal = () => {
      setRegistrationSuccess(false);
    };

    const handleCloseModalError = () => {
      setRegistrationError(false);
    };


  const handleSerieChange = (e) => {
    setSerieValue(e.target.value);
  };


  // Calcular el progreso como porcentaje
  const progress = xd.cantidad_total ? (xd.producidos / xd.cantidad_total) * 100 : 0;

  const getTurnoRange = (idTurno) => {
    const config = TURNOS_CONFIG[idTurno] || TURNOS_CONFIG[3];
    const ahora = dayjs();
    const inicioBase = ahora.startOf("day");

    if (!config.cruzaDia) {
      const inicio = inicioBase.hour(config.inicio.hour).minute(config.inicio.minute).second(0);
      const fin = inicioBase.hour(config.fin.hour).minute(config.fin.minute).second(0);
      return { inicio, fin };
    }

    const minutosActuales = ahora.hour() * 60 + ahora.minute();
    const finMinutos = config.fin.hour * 60 + config.fin.minute;

    if (minutosActuales < finMinutos) {
      const inicio = inicioBase.subtract(1, "day").hour(config.inicio.hour).minute(config.inicio.minute).second(0);
      const fin = inicioBase.hour(config.fin.hour).minute(config.fin.minute).second(0);
      return { inicio, fin };
    }

    const inicio = inicioBase.hour(config.inicio.hour).minute(config.inicio.minute).second(0);
    const fin = inicioBase.add(1, "day").hour(config.fin.hour).minute(config.fin.minute).second(0);
    return { inicio, fin };
  };

  const extraerTotalProduccion = (response, idTurno) => {
    if (!Array.isArray(response) || response.length === 0) return 0;

    const config = TURNOS_CONFIG[idTurno] || TURNOS_CONFIG[3];
    const registro = response[0] || {};
    const totalTurno = Number(registro[config.dataKey]);
    return Number.isNaN(totalTurno) ? 0 : totalTurno;
  };

  useEffect(() => {
    const fetchProduccionSemanalMensual = async () => {
      try {
        const hoy = dayjs();
        const rangoTurno = getTurnoRange(turnoIdEfectivo);
        const payloadActual = {
          fechaInicio: rangoTurno.inicio.format("YYYY-MM-DD HH:mm:ss"),
          fechaFin: rangoTurno.fin.format("YYYY-MM-DD HH:mm:ss"),
        };
        const payloadSemana = {
          fechaInicio: hoy.startOf("week").format("YYYY-MM-DD"),
          fechaFin: hoy.endOf("week").format("YYYY-MM-DD"),
        };
        const payloadMes = {
          fechaInicio: hoy.startOf("month").format("YYYY-MM-DD"),
          fechaFin: hoy.endOf("month").format("YYYY-MM-DD"),
        };

        const [respActual, respSemana, respMes] = await Promise.all([
          getDatosProduccion(payloadActual),
          getDatosProduccion(payloadSemana),
          getDatosProduccion(payloadMes),
        ]);

        setProduccionPeriodos({
          actual: extraerTotalProduccion(respActual, turnoIdEfectivo),
          semana: extraerTotalProduccion(respSemana, turnoIdEfectivo),
          mes: extraerTotalProduccion(respMes, turnoIdEfectivo),
        });
      } catch (error) {
        console.error("Error al obtener produccion semanal/mensual:", error);
        setProduccionPeriodos({ actual: 0, semana: 0, mes: 0 });
      }
    };

    fetchProduccionSemanalMensual();
  }, [sl, turnoIdEfectivo]);

  useEffect(() => {
    // Simulación de actualización de valores para prueba
    const interval = setInterval(() => {
      setChapas((prev) => (prev < chapasT ? prev + 1 : chapasT));
    }, 1000);

    return () => clearInterval(interval);
  }, [chapasT]);



  const fetchData = async (orden) => {

    try {
      const datos = await getOrdenOne(orden.orden);
      const estado_calandra = parseInt(orden.estado_calandra);
      // const estado =  parseInt(orden.estado);
      if (estado_calandra === 1 && datos.Estado != "programado") {
        // if (estado_calandra === 1 && estado > 1) {
        setxd(datos);
        const rows = datos ? [datos] : [];
        setData(rows);
        if (datos.producidos == datos.cantidad_total){
          secureStorage.setItem("Estado", "0");
          secureStorage.setItem("estado_calandra", "0");
          secureStorage.setItem("orden", "0");
        }
      } else {
        setxd("");
        setData([]);
      }
    } catch (error) {
      console.error("Error al obtener datos del backend:", error);
    }
  };


  const totalChapas = Number(xd.cantidad_total) || 0;
  const producidas = Number(xd.producidos) || 0;
  const pendientes = Math.max(totalChapas - producidas, 0);
  const porcentajeProduccion = totalChapas > 0 ? Math.min((producidas / totalChapas) * 100, 100) : 0;
  const porcentajePendiente = Math.max(100 - porcentajeProduccion, 0);

  const buildMetaDonutData = (actual, meta) => {
    const actualSeguro = Math.max(Number(actual) || 0, 0);
    const metaSegura = Math.max(Number(meta) || 0, 0);

    if (metaSegura === 0 && actualSeguro === 0) {
      return [{ id: "Sin datos", label: "Sin datos", value: 1 }];
    }

    const cumplido = Math.min(actualSeguro, metaSegura);
    const restante = Math.max(metaSegura - actualSeguro, 0);
    const excedente = Math.max(actualSeguro - metaSegura, 0);

    const dataset = [
      { id: "Produccion", label: "Produccion", value: cumplido },
      { id: "Restante", label: "Restante", value: restante },
    ];

    if (excedente > 0) {
      dataset.push({ id: "Excedente", label: "Excedente", value: excedente });
    }

    return dataset;
  };

  const renderDonutMeta = (titulo, actual, meta) => {
    const porcentaje = meta > 0 ? Math.round((actual / meta) * 100) : 0;

    return (
      <Box
        sx={{
          height: "45vh",
          width: { xs: "100%", md: "32%" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            textAlign: "end",
            paddingRight: "15%",
            width: "100%",
            fontFamily: "sans-serif",
          }}
        >
          <label style={{ fontSize: "26px", padding: "5px", color: "#ffffff", fontWeight: 700 }}>{`${titulo}:`}</label>
          <label style={{ fontSize: "30px", color: "#ffffff", fontWeight: 800 }}>{` ${actual}`}</label>
          <Box sx={{ color: "#9aa3c5", fontSize: "1rem", marginTop: "0.1rem", fontWeight: 600 }}>
            {`Meta: ${meta} (${porcentaje}%)`}
          </Box>
        </Box>

        <Box sx={{ height: "100%" }}>
          <ResponsivePie
            data={buildMetaDonutData(actual, meta)}
            theme={{
              axis: {
                domain: { line: { stroke: colors.grey[100] } },
                legend: { text: { fill: colors.grey[100] } },
                ticks: {
                  line: { stroke: colors.grey[100], strokeWidth: 1 },
                  text: { fill: colors.grey[100] },
                },
              },
              labels: { text: { fontSize: 20, fill: colors.grey[100] } },
              legends: { text: { fill: colors.grey[100] } },
            }}
            margin={{ top: 40, right: 55, bottom: 95, left: 55 }}
            innerRadius={0.5}
            padAngle={0.7}
            cornerRadius={3}
            activeOuterRadiusOffset={8}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor={colors.grey[100]}
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: "color" }}
            enableArcLabels={true}
            arcLabelsRadiusOffset={0.4}
            arcLabelsSkipAngle={7}
            arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
            arcLabels={({ datum }) => `${datum.value}`}
            colors={["#0161a9", "#ff6105", "#00c2cb"]}
            tooltip={({ datum: { label, value, color } }) => (
              <div
                style={{
                  padding: "12px",
                  color,
                  background: "#ffffff",
                  border: "0.5px solid black",
                }}
              >
                <strong>{`${label}: ${value}`}</strong>
              </div>
            )}
            legends={[
              {
                anchor: "bottom",
                direction: "row",
                justify: false,
                translateX: 0,
                translateY: 56,
                itemsSpacing: 0,
                itemWidth: 95,
                itemHeight: 22,
                itemTextColor: "#999",
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 20,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#ffffff",
                    },
                  },
                ],
              },
            ]}
          />
        </Box>
      </Box>
    );
  };

  const triggerCelebration = (tipoMeta, actual, meta, esPrueba = false) => {
    const mensaje = esPrueba
      ? "Prueba de celebracion activa"
      : `Meta alcanzada: ${tipoMeta} (${actual}/${meta})`;

    setCelebrationMessage(mensaje);
    setShowCelebration(true);

    const audio = new Audio("/sounds/alarm-1-without-reverberation-69339.mp3");
    audio.volume = 0.8;
    audio.play().catch((error) => {
      console.warn("No se pudo reproducir el audio:", error);
    });

    setTimeout(() => {
      setShowCelebration(false);
    }, 4500);
  };

  useEffect(() => {
    const metas = [
      { key: "actual", titulo: "Produccion Actual", actual: produccionPeriodos.actual, meta: META_TURNO },
      { key: "semana", titulo: "Produccion Semanal", actual: produccionPeriodos.semana, meta: META_SEMANA },
      { key: "mes", titulo: "Produccion Mensual", actual: produccionPeriodos.mes, meta: META_MES },
    ];

    metas.forEach((item) => {
      if (item.actual >= item.meta && !metasCelebradasRef.current[item.key]) {
        metasCelebradasRef.current[item.key] = true;
        triggerCelebration(item.titulo, item.actual, item.meta);
      }
      if (item.actual < item.meta) {
        metasCelebradasRef.current[item.key] = false;
      }
    });
  }, [produccionPeriodos.actual, produccionPeriodos.semana, produccionPeriodos.mes]);

  const handleKeyDown = (event) => {
    // Detecta si se presionó la tecla Tab
    if (event.key === 'Tab') {
      // Prevenir el comportamiento por defecto del tab (enfocar el siguiente input)
      event.preventDefault();
      // Abre el modal de reimpresión
      setModalOpenReImpresion(true);
    }
  };


  
  // Implementacion anterior de handleVerifySerie removida.
  


  const handleVerifySerie = async () => {
  setIsLoading(true);

  const valuesToSend = {
    orden: sl,
    id_producto: productData.id,
    cod: xd.cod,
    descripcion: xd.descripcion,
    id_clasificacion: parseInt(selectData.id_clasificacion),
    id_categoria: productData.id_categoria,
    medidas: productData.medidas,
    cantidad: 1,
    temperatura: parseInt(selectData.temperatura),
    id_pvb: parseInt(PVB),
    id_horarios: turnoIdEfectivo,
    id_usuario: USER,
    serie: xdd.serie,
    obs: selectData.defecto,
    motivo: " ",
    cantidad_entrada: xdd.chapa1,
    cantidad_utilizada: xdd.chapa2,
  };

  // const edit = {
  //   orden: sl,
  //   Estado: 5,
  //   estado_calandra: 1,
  //   serie: xdd,
  //   pvb: parseInt(PVB),
  //   chapa1: paquete1,
  //   chapa2: paquete2,
  // };

  const validarDatos = () => {
    if (xd.producidos === xd.cantidad_total) {
      toast.error(`La orden ha finalizado, inicia una nueva orden`, { position: "top-center", autoClose: 9000 });
      return false;
    }
    if (!valuesToSend.cantidad_entrada || !valuesToSend.cantidad_utilizada) {
      toast.error(`Paquetes no encontrados. Bipear nuevo paquete en Cargadora`, { position: "top-center", autoClose: 9000 });
      return false;
    }
    if (!valuesToSend.id_pvb) {
      toast.error(`PVB no encontrado. Actualice o registre uno`, { position: "top-center", autoClose: 9000 });
      return false;
    }
    return true;
  };

  try {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (!validarDatos()) return;

    const insertResponse = await PostDatosCalandra(valuesToSend);
    const { id_produccion } = insertResponse.resp;
    getTicket(id_produccion);

    // await updateLavadora(sl, edit);
    setRegistrationSuccess(true);
    selectData.temperatura = "";
  } catch (error) {
    console.error("❌ Error en handleVerifySerie:", error);
    toast.error(error.message || "Error general", { position: "top-center" });
    setRegistrationError(true);
    setError(error.message);
  } finally {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }
};

  useEffect(() => {
    // Agregar evento de escucha para la tecla "Tab" en el formulario
    document.addEventListener('keydown', handleKeyDown);

    // Limpiar el event listener cuando el componente se desmonte
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);


  const getTicket = async (id) => {
    const response = await getOneDatosTicket(id);
    if (response) {
      const { cod, codigo, descripcion, medidas, clasificacion, serie, id_produccion,obs, created_At, tipo, orden, codFabrica } = response;
      const fecha = dayjs(created_At).format("DD/MM/YYYY HH:mm");

      const ticketData = {
        cod: cod,
        codigo: codigo,
        descripcion: descripcion,
        medidas: medidas,
        clasificacion: clasificacion,
        serie: serie,
        obs: obs,
        id_produccion: id_produccion,
        fecha: fecha,
        tipo: tipo,
        orden: orden,
        codFabrica: codFabrica,
      };

      // Call function to print ticket
      generateZPL(ticketData);
    } else {
      console.error("No se encontró el ticket con el ID proporcionado");
    }
  };

const generateZPL = async (values) => {

  const formatText = (text, maxLength) => {
    const words = text.split(" ");
    let lines = [];
    let currentLine = "";

    for (let word of words) {
      if ((currentLine + word).length > maxLength) {
        lines.push(currentLine.trim());
        currentLine = word + " ";
      } else {
        currentLine += word + " ";
      }
    }

    if (currentLine.trim()) {
      lines.push(currentLine.trim());
    }

    return lines;
  };
  const descripcionLines = formatText(values.codigo, 43);
  let reflectivo = "";
      if(values.tipo == null){
        reflectivo = " ";
      }else{
        reflectivo = values.tipo;
      }

let zpl = `
            ^XA
      ^PW800
      ^LL400
    `;

    descripcionLines.forEach((line, index) => {
      zpl += `^FO100,${25 + index * 30}^A0N,28,28^FD${line}^FS\n`;
    });

    zpl += `^FO100,${80 + descripcionLines.length * 30 + 30}^A0N,28,28^FD^FS\n`;

    // ✅ Solo si hay tipo, agregar el rectángulo y texto
    if (values.tipo != null) {
      zpl += `
        // Rectángulo negro para "REFLECTIVO"
        ^FO0,10^GB80,390,80,B^FS

        // Texto blanco dentro del rectángulo negro
        ^FO10,90^A0R,50,50^FR^FDREFLECTIVO^FS

        // Texto reflectivo
        ^FO180,180^A0N,35,35^FD${reflectivo}^FS
      `;
    }

    zpl += `
      // Medidas
      ^FO200,110^A0N,35,35^FD${values.medidas}^FS

      // Código QR
      ^FO540,100^BQN,2,8^FDQA,${values.serie}^FS

          `;

          // Solo si el cod comienza con AA, agregar los comandos extra
          if (values.cod && values.cod.startsWith("AA")) {
            zpl += `
        ^FO318,300^A0N,60,60^FDAGC^FS
        ^FO320,300^A0N,60,60^FDAGC^FS
        ^FO100,210^A0N,35,35^FDAGC: ${values.codFabrica}^FS
      `;
          }

          zpl += `

      // ID Producción, fecha y serie
      ^FO100,250^A0N,35,35^FDOP: ${values.orden}^FS
      ^FO100,320^A0N,35,35^FD${values.id_produccion}^FS
      ^FO500,320^A0N,35,35^FD${values.serie}^FS
      ^XZ
    `;

  // let zplx = `
  // ^XA
  // ^PW800        // Ancho de la etiqueta (400 puntos = 10 cm)
  // ^LL400        // Longitud de la etiqueta (200 puntos = 5 cm)

  // `;
  // descripcionLines.forEach((line, index) => {
  //   zplx += `^FO30,${25 + index * 30}^A0N,28,28^FD${line}^FS\n`;
  // });
  // zplx += `
  // ^FO30,${25 + descripcionLines.length * 30 + 30}^A0N,28,28^FD^FS
  // // Medidas
  // ^FO200,110^A0N,35,35^FD${values.medidas}^FS

  // // Clasificación

  // // Código QR, más grande

  // ^FO540,100^BQN,2,8^FDQA,${values.serie}^FS

  // // ID Producción, fecha y serie
  // ^FO20,320^A0N,35,35^FD${values.id_produccion}^FS
  // ^FO190,320^A0N,35,35^FD${values.fecha}^FS
  // ^FO550,320^A0N,35,35^FD${values.serie}^FS

  // ^XZ
  // `;

  if (window.BrowserPrint) { // Asegúrate de que BrowserPrint está disponible
    window.BrowserPrint.getDefaultDevice("printer",
    (device) => {
        if (device) {
        setPrinterInfo(`Dispositivo predeterminado encontrado: ${device.name}`);
        let zplCommand = zpl;

        // 3. Usar la función send para enviar los datos al dispositivo
        device.send(zplCommand, function(response) {
        }, function(error) {
            console.error("Error al enviar datos:", error);
        });
        } else {
        setPrinterInfo("No hay una impresora predeterminada configurada.");
        }
    },
    (error) => {
        setErrorMessage(`Error al obtener el dispositivo predeterminado: ${error}`);
    }
    );
  } else {
    setErrorMessage('BrowserPrint no está disponible.');
  }
  };



  return (
    // container

    <Box

      sx={{
        background: "#111830",
        height: "100vh",
        width: "100vw",
        padding: { xs: "0.8rem", md: "1rem 1.2rem" },
        margin: 0,
        borderRadius: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {/* container flex */}
      <Box
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        {/* container graficos */}
        <Box
          sx={{
            background: "#111830",
            width: "100%",
            height: "100%",
            borderTop: "3px solid #242b43",
            padding: { xs: "0.6rem", md: "1rem" },
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              background: "#1b2136",
              borderRadius: "8px",
              padding: "1.2rem",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: "4rem",
                fontWeight: 700,
                color: "#cedc00",
                textShadow: "2px 2px 2px black",
              }}
            >
              Graficos de Produccion
            </Typography>

            <Typography sx={{ color: "#9aa3c5", fontSize: "1.2rem", fontWeight: 600 }}>
              {`Turno activo: ${turnoConfig.nombre} (${turnoConfig.horario})`}
            </Typography>

            {/* PVB Data Section */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #1b2136 0%, #242b43 100%)",
                border: "2px solid #00c2cb",
                borderRadius: "8px",
                padding: "1rem",
                display: "flex",
                gap: "2rem",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography sx={{ color: "#9aa3c5", fontSize: "1rem", fontWeight: 600 }}>
                  Código PVB
                </Typography>
                <Typography
                  sx={{
                    color: "#cedc00",
                    fontSize: "1.8rem",
                    fontWeight: 800,
                    marginTop: "0.3rem",
                  }}
                >
                  {pvbData.codigo}
                </Typography>
              </Box>
              <Box sx={{ borderLeft: "2px solid #00c2cb", paddingLeft: "2rem" }}>
                <Typography sx={{ color: "#9aa3c5", fontSize: "1rem", fontWeight: 600 }}>
                  Media Disponible (m²)
                </Typography>
                <Typography
                  sx={{
                    color: pvbData.media <= 3000 ? "#ff6105" : "#00c2cb",
                    fontSize: "1.8rem",
                    fontWeight: 800,
                    marginTop: "0.3rem",
                  }}
                >
                  {pvbData.media.toLocaleString()}
                </Typography>
                {pvbData.media <= 3000 && (
                  <Typography sx={{ color: "#ff6105", fontSize: "0.9rem", marginTop: "0.3rem", fontWeight: 600 }}>
                    ⚠️ Stock bajo
                  </Typography>
                )}
              </Box>
            </Box>

            <Box>
              <Button
                variant="contained"
                onClick={() => triggerCelebration("Prueba", 1, 1, true)}
                sx={{
                  backgroundColor: "#00c2cb",
                  color: "#0b1225",
                  fontWeight: 800,
                  fontSize: "1rem",
                  "&:hover": {
                    backgroundColor: "#00a7ae",
                  },
                }}
              >
                Probar Celebracion
              </Button>
            </Box>

            {showCelebration && (
              <Box
                sx={{
                  position: "fixed",
                  top: "10%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: "linear-gradient(135deg, #00c2cb 0%, #cedc00 100%)",
                  color: "#0b1225",
                  padding: "1rem 1.6rem",
                  borderRadius: "12px",
                  zIndex: 2000,
                  boxShadow: "0 8px 30px rgba(0,0,0,0.35)",
                  textAlign: "center",
                  animation: "popIn 0.35s ease",
                  "@keyframes popIn": {
                    "0%": { opacity: 0, transform: "translateX(-50%) scale(0.7)" },
                    "100%": { opacity: 1, transform: "translateX(-50%) scale(1)" },
                  },
                }}
              >
                <Typography sx={{ fontSize: "1.7rem", fontWeight: 900 }}>Meta Cumplida</Typography>
                <Typography sx={{ fontSize: "1.1rem", fontWeight: 700 }}>{celebrationMessage}</Typography>
                <Typography sx={{ fontSize: "1.8rem", marginTop: "0.2rem" }}>***</Typography>
              </Box>
            )}

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                width: "100%",
                gap: { xs: "0.9rem", md: 0 },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              {renderDonutMeta("Produccion Actual por Turno", produccionPeriodos.actual, META_TURNO)}
              {renderDonutMeta("Produccion Semanal", produccionPeriodos.semana, META_SEMANA)}
              {renderDonutMeta("Produccion Mensual", produccionPeriodos.mes, META_MES)}
            </Box>

            <Typography
              variant="h2"
              sx={{
                fontSize: "1.6rem",
                fontWeight: 700,
                color: "#ffffff",
                textShadow: "2px 2px 2px black",
                marginTop: "0.2rem",
              }}
            >
              Datos de Produccion
            </Typography>

            <Box
              sx={{
                background: "#2a324d",
                borderRadius: "8px",
                padding: "1rem",
                display: "grid",
                gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                gap: "0.7rem",
              }}
            >
              <Typography sx={{ fontSize: "3rem", color: "#9aa3c5", fontWeight: 700 }}>Orden</Typography>
              <Typography sx={{ fontSize: "3rem", color: "#ffffff", textAlign: "right", fontWeight: 700 }}>{xd?.orden || "-"}</Typography>
              <Typography sx={{ fontSize: "3rem", color: "#9aa3c5", fontWeight: 700 }}>Codigo</Typography>
              <Typography sx={{ fontSize: "3rem", color: "#ffffff", textAlign: "right", fontWeight: 700 }}>{productData?.cod || xd?.cod || "-"}</Typography>
              <Typography sx={{ fontSize: "3rem", color: "#9aa3c5", fontWeight: 700 }}>PVB</Typography>
              <Typography sx={{ fontSize: "3rem", color: "#ffffff", textAlign: "right", fontWeight: 700 }}>{xd?.pvb || PVB || "-"}</Typography>
            </Box>

            <Box
              sx={{
                background: "#2a324d",
                borderRadius: "8px",
                padding: "1rem",
                display: "flex",
                flexDirection: "column",
                gap: "0.7rem",
              }}
            >
              <Typography sx={{ color: "#ffffff", fontWeight: 800, fontSize: "1.3rem" }}>Avance de Orden</Typography>
              <Box sx={{ display: "flex", justifyContent: "space-between", color: "#9aa3c5", fontSize: "1.05rem", fontWeight: 700 }}>
                <span>Producidas: {producidas}</span>
                <span>Pendientes: {pendientes}</span>
                <span>Total: {totalChapas}</span>
              </Box>
              <Box sx={{ height: "12px", background: "#111830", borderRadius: "999px", overflow: "hidden" }}>
                <Box
                  sx={{
                    width: `${porcentajeProduccion}%`,
                    height: "100%",
                    background: "linear-gradient(90deg, #00c2cb 0%, #cedc00 100%)",
                    transition: "width 0.4s ease",
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", fontSize: "1.05rem" }}>
                <Typography sx={{ color: "#00c2cb", fontWeight: 700 }}>{Math.round(porcentajeProduccion)}% completado</Typography>
                <Typography sx={{ color: "#ff8b4c", fontWeight: 700 }}>{Math.round(porcentajePendiente)}% pendiente</Typography>
              </Box>
            </Box>
          </Box>
          <ModalCharge isLoading={isLoading} />
          {registrationSuccess && (
            <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
          )}
          {registrationError && (
            <ModalError
              open={registrationError}
              onClose={handleCloseModalError}
              error={error}
            />
          )}

          <ModalReImpresion
            open={modalOpenReImpresion}
            onClose={() => setModalOpenReImpresion(false)}
            orden={xd}
          />

          <ModalClasificacion
            open={modalOpenClasifi}
            onClose={() => setModalOpenClasifi(false)}
            onSelect={(data) => {
            setSelectData((prev) => ({
                ...prev,
                clasificacion: data.descripcion, // Actualiza la propiedad 'clasificacion'
                id_clasificacion: data.id,
              }));
              setModalOpen(false);
            }}
          />

          {/* <ModalCaballete
            open={modalOpenCaballete}
            onClose={() => setModalOpenCaballete(false)}
            onSelect={(data) => {
            setCab((prev) => ({
                ...prev,
                id_caballete: data.id, // Actualiza la propiedad 'clasificacion'
              }));
              setModalOpen(false);
            }}
            serviceType={0}

          /> */}

          <ModalMotivosCalandra
            open={modalOpenMotivo}
            onClose={() => setModalOpenMotivo(false)}
            onSelect={(data) => {
              setSelectData((prev) => ({
                  ...prev,
                  defecto: data.descripcion, // Actualiza la propiedad 'clasificacion'
                }));
                setModalOpen(false);
              }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CalandraDatosProductos;
